import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Bell } from "lucide-react";

export function AlertsBell() {
  const nav = useNavigate();
  const [data, setData] = useState({ items: [], unread: 0 });
  const [isOpen, setIsOpen] = useState(false);
  const load = useCallback(() => api.get("/alerts").then(({ data }) => setData(data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, [load]);
  const open = async (a) => {
    await api.post(`/alerts/${a.id}/read`).catch(() => {});
    load();
    setIsOpen(false);
    nav(`${a.business === "loan" ? "/loan-leads" : "/leads"}?q=${encodeURIComponent(a.lead_ref || "")}`);
  };
  return (
    <Popover open={isOpen} onOpenChange={(o) => { setIsOpen(o); if (o) load(); }}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" title="Alerts" data-testid="alerts-bell">
          <Bell className="h-5 w-5" />
          {data.unread > 0 && <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-600 text-white text-[10px] font-bold flex items-center justify-center" data-testid="alerts-unread-count">{data.unread > 99 ? "99+" : data.unread}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0" data-testid="alerts-panel">
        <div className="flex items-center justify-between px-4 py-3 border-b border-border">
          <span className="font-semibold text-sm">Alerts</span>
          {data.unread > 0 && <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => api.post("/alerts/read-all").then(load)} data-testid="alerts-read-all">Mark all read</Button>}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {data.items.length === 0 ? <p className="text-sm text-muted-foreground p-4">No alerts. All leads are on time.</p> : data.items.map((a) => (
            <button key={a.id} onClick={() => open(a)} className={`w-full text-left px-4 py-3 border-b border-border hover:bg-muted/60 ${a.read ? "opacity-60" : ""}`} data-testid="alert-item">
              <div className="text-sm font-semibold">{a.type === "website_enquiry" ? `New ${(a.kind || "website enquiry").toLowerCase()}` : a.type === "new_lead_not_called" ? "New lead not called" : "Follow-up missed"}{!a.read && <span className="ml-2 inline-block h-2 w-2 rounded-full bg-rose-600" />}</div>
              <div className="text-xs text-muted-foreground">{a.lead_name} · {a.lead_ref} · {a.assignee_name}</div>
              <div className="text-[11px] text-muted-foreground">{a.type === "website_enquiry" ? "Received" : "Due"} {fmtDateTime(a.due_at)}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
